/**
 * Replaces `{name}` placeholders in a template with values from `params`.
 * Mirrors the legacy UWM `stringUtils.formatByName`.
 */
export const formatByName = (template: string, params?: Record<string, unknown>): string => {
    if (!template) return template ?? '';

    return template.replace(/\{\{|\}\}|\{(\w+)\}/g, (m, n: string | undefined) => {
        if (m === '{{') return '{';
        if (m === '}}') return '}';
        const value = n != null ? params?.[n] : undefined;
        return value == null ? m : String(value);
    });
};
